import { useEventListener } from "@vueuse/core";

const YANDEX_GOAL_ID = 318438575;
const YM_LOADED_EVENT_NAME = 'ym-loaded';

export default function useAnalytics(hasYmListener?: boolean) {
  const yandexMetrikaLoaded = useState(() => false);
  const { gtag, yandexMetrica, id } = useBranch();

  if (hasYmListener) {
    useEventListener(window, YM_LOADED_EVENT_NAME, () => {
      yandexMetrikaLoaded.value = true;
    }, { once: true });
  }

  return {
    yandexMetrikaLoaded,

    setGtag() {
      if (!gtag) {
        console.warn(`No gtag for branch "${id}". Skipped Analytics setup.`);
        return;
      }
      useHead({
        script: [{
          innerHTML: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtag}');
          `,
          onerror: e => console.error('Failed to load gtag', e)
        }]
      });
    },

    setYandexMetrica() {
      if (!yandexMetrica) return;
      useHead({
        script: [{
          innerHTML: `
            (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
            m[i].l=1*new Date();
            for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
            k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
            (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
            ym(${yandexMetrica}, "init", {
              clickmap:true,
              trackLinks:true,
              accurateTrackBounce:true
            });
            dispatchEvent(new CustomEvent('${YM_LOADED_EVENT_NAME}'));
          `,
          defer: true
        }]
      });
    },

    callYandexReachGoal() {
      if (!yandexMetrica) return;
      window.ym!(yandexMetrica, 'reachGoal', YANDEX_GOAL_ID);
    }
  }
}